import { Input } from "antd";
import { styled } from "styled-components";

export const InputStyle = styled(Input)`
  background: #f4f7fe;
  border-color: #f4f7fe;
  border-radius: 12px;
  min-height: 48px;
`;
